const common = {
    no_data: 'Brak dostępnych danych',
    header: {
        business_name: 'Twoja Firma'
    },
    download_app: {
        text: 'Aby korzystać z wersji web Simply, prosimy używać laptopa lub komputera stacjonarnego.',
        button: 'Pobierz wersję mobilną'
    },
    unknown: 'Nieznany',
    request_error: 'Wystąpił błąd. Proszę spróbować ponownie! Lub skontaktuj się z pomocą techniczną.',
    home: 'Strona główna',
    dashboard: 'Panel',
    product: 'Produkt',
    add_product: 'Dodaj produkt',
    edit_product: 'Edytuj produkt',
    stock_in: 'Przyjęcie do magazynu',
    Sales_Turnover: 'Obrót ze sprzedaży',
    profit: 'Zysk',
    stock_out: 'Wydanie z magazynu',
    staff: 'Personel',
    stock_audit: 'Inwentaryzacja',
    button: {
        save: 'Zapisz',
        save_and_add_more: 'Zapisz i dodaj kolejny',
        submit: 'Zatwierdź',
        done: 'Gotowe',
        edit: 'Edytuj',
        save_edit: 'Zapisz zmiany',
        yes: 'Tak',
        clear: 'Wyczyść',
        delete: 'Usuń',
        cancel: 'Anuluj',
        reset: 'Resetuj'
    },
    select_date: 'Wybierz datę',
    select_action: 'Wybierz akcję',
    mandatory: ' *(Wymagane)',
    not_mandatory: '(Nieobowiązkowe)',
    business: 'Firma',
    account: 'Konto',
    profile: 'Profil',
    setting: 'Ustawienia',
    whichLanguage: 'Polski',
    headerDashboard: 'Zostań VIP',
    contact_us: 'Kontakt',
    logout: 'Wyloguj',
    confirm_logout: 'Czy na pewno chcesz się wylogować?',
    logout_description: 'Będziesz musiał zalogować się ponownie, aby uzyskać dostęp do swoich firm.',
    category: 'Kategoria',
    add_category: 'Dodaj kategorię',
    data: 'Dane',
    history: 'Historia',
    lowStockAlert: 'Alert niskiego stanu',
    Expenses: 'Wydatki',
    lowStockAlertButton: 'Dodaj ilość zapasu bezpieczeństwa',
    message: {
        login_success: 'Pomyślnie zalogowano!',
        onboard_success: 'Hura!! Twoja przygoda się rozpoczęła!',
        successfully_saved: 'Dane zapisano pomyślnie',
        successfully_deleted: 'Dane usunięto pomyślnie',
        error_required_field: 'Pole wymagane nie może być puste',
        no_access: 'Brak dostępu',
        no_permission: 'Nie masz uprawnień',
        error_update_history: 'Nie udało się zaktualizować historii'
    },
    no_permission_dialog: {
        title: 'Brak uprawnień',
        description: "Nie masz uprawnień do przeglądania Wydatków. Skontaktuj się z administratorem."
    },
    feedback: 'Prześlij opinię',
    contact: 'Kontakt',
    add: 'Dodaj',
    supplier: 'Dostawca',
    customer: 'Klient',
    random: 'Losowy',
    scan: 'Skanuj',
    enter: 'Zaloguj skanując kod kreskowy',
    terms: {
        text: 'Kontynuując, zgadzasz się na',
        link: 'Politykę Prywatności'
    },
    others: 'Inne',
    calender: {
        presets: {
            today: 'Dzisiaj',
            yesterday: 'Wczoraj',
            last_7_days: 'Ostatnie 7 dni',
            last_30_days: 'Ostatnie 30 dni',
            this_month: 'Bieżący miesiąc',
            last_month: 'Poprzedni miesiąc',
            custom_range: 'Zakres niestandardowy'
        }
    },
    print_large: 'Drukuj duży (A4)',
    print_letter: 'Drukuj list (US)',
    print_dot_matrix: 'Drukuj duży (Macierzowy)',
    print_medium: 'Drukuj średni (75mm)',
    print_small: 'Drukuj mały (48mm)',
    format: 'Format papieru',
    preview: 'Podgląd',
    view_invoice: 'Faktura',
    view_chalan: 'Challan',
    price: 'Cena',
    stock: 'Stan',
    quantity: 'Ilość',
    total: 'Razem',
    print_footer_left: 'Utworzono przez',
    print_footer_center: 'Wydrukowano',
    print_footer_date: 'dnia',
    print_to: 'Do',
    language: 'Polski',
    dateStatus: 'Ostatnie 7 dni',
    placeholder: 'Typ transakcji',
    staffHistory: 'Wybierz pracownika',
    languageTitle: 'Polski',
    date: 'Data',
    download: 'Pobierz',
    download_excel: 'Pobierz Excel',
    download_pdf: 'Pobierz kod kreskowy',
    currentTitle: 'Waluta',
    Selectperiod: 'Wybierz okres',
    TransactionType: 'Typ transakcji',
    SelectCustomer: 'Wybierz klienta',
    invoice: 'Faktura',
    login: {
        google: 'Zaloguj się przez Google',
        apple: 'Zaloguj się przez Apple'
    },
    trusted_by: {
        title: 'Zaufanie ponad 50 000 firm'
    },
    privacyPolicyOne: "Logując się, zgadzasz się na",
    privacyPolicyTwo: 'Politykę Prywatności',
    manufacture: 'Produkcja',
    warehouse: 'Magazyny',
    error: {
        title: 'Ups! Coś poszło nie tak',
        description: 'Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę lub wrócić do strony głównej.',
        refresh: 'Odśwież stronę',
        go_back: 'Wróć do strony głównej',
        not_found: 'Strona nie znaleziona'
    },
    totalPurchasePrice: 'Całkowita cena zakupu',
    pageTotalPurchaseAmount: 'Łączna kwota zakupu na stronie',
    approval_status: 'Status zatwierdzenia',
    pending: 'Oczekujące',
    approved: 'Zatwierdzone',
    rejected: 'Odrzucone',
    select_fields: 'Wybierz pola',
    syncWithTally: 'Synchronizuj z Tally',
    importFromTally: 'Importuj z Tally',
    exportToTally: 'Eksportuj do Tally',
    All: 'Wszystkie',
    Approval: 'Zatwierdzenie'
}

export default common